// City data for SEO landing pages
// Structured for AI-readability (ChatGPT, Gemini, Claude)

export const cityData = {
  // ========== MIAMI-DADE COUNTY ==========
  'miami': {
    name: 'Miami',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'miami',
    nearbyCity1: 'Coral Gables',
    nearbyCity2: 'Doral',
    permitInfo: 'Yes - Permits are required for all impact window installations in Miami and across South Florida. Permit timelines vary by municipality. We handle the entire permitting process.',
    installTime: '1-3 days for most residential projects, depending on size.',
    localContext: 'Downtown Miami and coastal areas face high hurricane risk, making impact-rated windows essential for property protection and insurance savings.'
  },
  'miami-beach': {
    name: 'Miami Beach',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'miami-beach',
    nearbyCity1: 'Miami',
    nearbyCity2: 'Sunny Isles Beach',
    permitInfo: 'Yes - Miami Beach requires permits and follows strict HVHZ (High-Velocity Hurricane Zone) codes.',
    installTime: '1-3 days for typical installations.',
    localContext: 'Beachfront properties require HVHZ-certified impact windows due to extreme wind exposure and saltwater corrosion risks.'
  },
  'coral-gables': {
    name: 'Coral Gables',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'coral-gables',
    nearbyCity1: 'Miami',
    nearbyCity2: 'Pinecrest',
    permitInfo: 'Yes - Coral Gables has strict permitting and HOA requirements. We coordinate with local HOAs.',
    installTime: '1-3 days, plus HOA approval time if applicable.',
    localContext: 'Historic Coral Gables homes often require custom-sized impact windows to maintain architectural integrity while meeting modern code.'
  },
  'kendall': {
    name: 'Kendall',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'kendall',
    nearbyCity1: 'Pinecrest',
    nearbyCity2: 'Cutler Bay',
    permitInfo: 'Yes - Permits are required for all impact window installations in Kendall and across South Florida. We handle the entire permitting process.',
    installTime: '1-3 days for most residential projects.',
    localContext: 'Kendall\'s suburban homes benefit from impact windows for hurricane protection and reduced insurance premiums.'
  },
  'doral': {
    name: 'Doral',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'doral',
    nearbyCity1: 'Miami',
    nearbyCity2: 'Sweetwater',
    permitInfo: 'Yes - Permits are required in Doral and across South Florida. HOA approval needed for most communities. Permit timelines vary by municipality.',
    installTime: '1-3 days, depending on project scope.',
    localContext: 'Doral\'s newer construction often includes builder-grade windows that homeowners upgrade to premium impact-rated products.'
  },
  'homestead': {
    name: 'Homestead',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'homestead',
    nearbyCity1: 'Cutler Bay',
    nearbyCity2: 'Florida City',
    permitInfo: 'Yes - Homestead requires permits and follows post-Hurricane Andrew building codes.',
    installTime: '1-3 days for typical installations.',
    localContext: 'Homestead was severely impacted by Hurricane Andrew. Modern impact windows are now standard for all new and replacement projects.'
  },
  'hialeah': {
    name: 'Hialeah',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'hialeah',
    nearbyCity1: 'Miami',
    nearbyCity2: 'West Miami',
    permitInfo: 'Yes - Hialeah requires permits for all impact window installations. Permit timelines vary by municipality.',
    installTime: '1-3 days for most projects.',
    localContext: 'Hialeah homeowners frequently upgrade to impact windows for insurance discounts and protection from tropical storms.'
  },
  'aventura': {
    name: 'Aventura',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'aventura',
    nearbyCity1: 'North Miami',
    nearbyCity2: 'Sunny Isles Beach',
    permitInfo: 'Yes - Aventura requires permits for all impact installations. High-rise buildings require special approvals. Permit timelines vary.',
    installTime: '1-3 days for single-family homes; longer for condos (building approval required).',
    localContext: 'Aventura\'s luxury high-rises and waterfront properties demand premium impact-rated products for wind resistance and noise reduction.'
  },
  'north-miami': {
    name: 'North Miami',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'north-miami',
    nearbyCity1: 'Miami',
    nearbyCity2: 'Aventura',
    permitInfo: 'Yes - North Miami requires permits for all impact installations. Permit timelines vary by municipality.',
    installTime: '1-3 days for typical residential projects.',
    localContext: 'North Miami properties benefit from impact windows for hurricane protection and energy efficiency in South Florida\'s climate.'
  },
  'cutler-bay': {
    name: 'Cutler Bay',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'cutler-bay',
    nearbyCity1: 'Kendall',
    nearbyCity2: 'Homestead',
    permitInfo: 'Yes - Cutler Bay requires permits for all impact installations. Permit timelines vary by municipality.',
    installTime: '1-3 days for most residential installations.',
    localContext: 'Cutler Bay is in a high-wind zone. Impact windows are critical for protecting homes during hurricane season.'
  },
  'pinecrest': {
    name: 'Pinecrest',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'pinecrest',
    nearbyCity1: 'Coral Gables',
    nearbyCity2: 'Kendall',
    permitInfo: 'Yes - Pinecrest has strict permitting. Many properties have HOA requirements.',
    installTime: '1-3 days, plus HOA approval time.',
    localContext: 'Pinecrest\'s luxury homes often feature custom impact windows to match architectural style while meeting Florida Building Code.'
  },
  'palmetto-bay': {
    name: 'Palmetto Bay',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'palmetto-bay',
    nearbyCity1: 'Pinecrest',
    nearbyCity2: 'Cutler Bay',
    permitInfo: 'Yes - Palmetto Bay requires permits. Many properties have HOA requirements. Permit timelines vary by municipality.',
    installTime: '1-3 days for typical projects.',
    localContext: 'Palmetto Bay homeowners prioritize impact windows for storm protection and enhanced curb appeal.'
  },
  'sweetwater': {
    name: 'Sweetwater',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'sweetwater',
    nearbyCity1: 'Doral',
    nearbyCity2: 'West Miami',
    permitInfo: 'Yes - Sweetwater requires permits for all impact installations. Permit timelines vary by municipality.',
    installTime: '1-3 days for most installations.',
    localContext: 'Sweetwater residents upgrade to impact windows for hurricane safety and lower insurance costs.'
  },
  'west-miami': {
    name: 'West Miami',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'west-miami',
    nearbyCity1: 'Miami',
    nearbyCity2: 'Sweetwater',
    permitInfo: 'Yes - West Miami requires permits for all impact installations. Permit timelines vary by municipality.',
    installTime: '1-3 days for typical residential projects.',
    localContext: 'West Miami homeowners choose impact windows to protect against hurricanes and reduce energy bills.'
  },
  'sunny-isles-beach': {
    name: 'Sunny Isles Beach',
    county: 'Miami-Dade',
    state: 'FL',
    slug: 'sunny-isles-beach',
    nearbyCity1: 'Aventura',
    nearbyCity2: 'Miami Beach',
    permitInfo: 'Yes - Sunny Isles Beach requires HVHZ-compliant permits.',
    installTime: '1-3 days for homes; condo buildings require board approval.',
    localContext: 'Beachfront high-rises in Sunny Isles demand premium HVHZ-rated impact windows for extreme wind and salt exposure.'
  },

  // ========== BROWARD COUNTY ==========
  'fort-lauderdale': {
    name: 'Fort Lauderdale',
    county: 'Broward',
    state: 'FL',
    slug: 'fort-lauderdale',
    nearbyCity1: 'Hollywood',
    nearbyCity2: 'Pompano Beach',
    permitInfo: 'Yes - Broward County requires permits for all impact window installations.',
    installTime: '1-3 days for most residential projects.',
    localContext: 'Fort Lauderdale\'s coastal location makes impact windows essential for hurricane protection and insurance savings.'
  },
  'hollywood': {
    name: 'Hollywood',
    county: 'Broward',
    state: 'FL',
    slug: 'hollywood',
    nearbyCity1: 'Fort Lauderdale',
    nearbyCity2: 'Pembroke Pines',
    permitInfo: 'Yes - Hollywood requires Broward County permits.',
    installTime: '1-3 days for typical installations.',
    localContext: 'Hollywood homes near the beach require HVHZ-certified impact windows for wind resistance and storm protection.'
  },
  'pembroke-pines': {
    name: 'Pembroke Pines',
    county: 'Broward',
    state: 'FL',
    slug: 'pembroke-pines',
    nearbyCity1: 'Miramar',
    nearbyCity2: 'Weston',
    permitInfo: 'Yes - Pembroke Pines follows Broward County permitting requirements.',
    installTime: '1-3 days for most residential projects.',
    localContext: 'Pembroke Pines residents upgrade to impact windows for hurricane safety and to meet insurance requirements.'
  },
  'miramar': {
    name: 'Miramar',
    county: 'Broward',
    state: 'FL',
    slug: 'miramar',
    nearbyCity1: 'Pembroke Pines',
    nearbyCity2: 'Hollywood',
    permitInfo: 'Yes - Miramar requires Broward County permits.',
    installTime: '1-3 days for typical projects.',
    localContext: 'Miramar homeowners choose impact windows for storm protection and energy efficiency.'
  },
  'plantation': {
    name: 'Plantation',
    county: 'Broward',
    state: 'FL',
    slug: 'plantation',
    nearbyCity1: 'Fort Lauderdale',
    nearbyCity2: 'Davie',
    permitInfo: 'Yes - Plantation follows Broward County permit requirements.',
    installTime: '1-3 days for most installations.',
    localContext: 'Plantation residents invest in impact windows to protect against hurricanes and reduce insurance premiums.'
  },
  'davie': {
    name: 'Davie',
    county: 'Broward',
    state: 'FL',
    slug: 'davie',
    nearbyCity1: 'Plantation',
    nearbyCity2: 'Weston',
    permitInfo: 'Yes - Davie requires Broward County permits.',
    installTime: '1-3 days for typical residential projects.',
    localContext: 'Davie\'s suburban and equestrian properties benefit from impact windows for storm protection and noise reduction.'
  },
  'weston': {
    name: 'Weston',
    county: 'Broward',
    state: 'FL',
    slug: 'weston',
    nearbyCity1: 'Pembroke Pines',
    nearbyCity2: 'Davie',
    permitInfo: 'Yes - Weston has strict HOA and Broward County permit requirements.',
    installTime: '1-3 days, plus HOA approval time.',
    localContext: 'Weston\'s master-planned communities require HOA approval for impact window installations to maintain aesthetic standards.'
  },
  'sunrise': {
    name: 'Sunrise',
    county: 'Broward',
    state: 'FL',
    slug: 'sunrise',
    nearbyCity1: 'Fort Lauderdale',
    nearbyCity2: 'Plantation',
    permitInfo: 'Yes - Sunrise follows Broward County permitting.',
    installTime: '1-3 days for most projects.',
    localContext: 'Sunrise homeowners upgrade to impact windows for hurricane protection and lower energy costs.'
  },
  'deerfield-beach': {
    name: 'Deerfield Beach',
    county: 'Broward',
    state: 'FL',
    slug: 'deerfield-beach',
    nearbyCity1: 'Pompano Beach',
    nearbyCity2: 'Boca Raton',
    permitInfo: 'Yes - Deerfield Beach requires Broward County permits.',
    installTime: '1-3 days for typical installations.',
    localContext: 'Beachfront properties in Deerfield Beach need impact windows rated for high-wind zones.'
  },
  'pompano-beach': {
    name: 'Pompano Beach',
    county: 'Broward',
    state: 'FL',
    slug: 'pompano-beach',
    nearbyCity1: 'Fort Lauderdale',
    nearbyCity2: 'Deerfield Beach',
    permitInfo: 'Yes - Pompano Beach follows Broward County permit requirements.',
    installTime: '1-3 days for most residential projects.',
    localContext: 'Pompano Beach coastal homes require HVHZ-rated impact windows for hurricane protection.'
  },
  'coral-springs': {
    name: 'Coral Springs',
    county: 'Broward',
    state: 'FL',
    slug: 'coral-springs',
    nearbyCity1: 'Parkland',
    nearbyCity2: 'Tamarac',
    permitInfo: 'Yes - Coral Springs requires Broward County permits.',
    installTime: '1-3 days for typical projects.',
    localContext: 'Coral Springs residents choose impact windows for storm safety and to meet modern building codes.'
  },
  'tamarac': {
    name: 'Tamarac',
    county: 'Broward',
    state: 'FL',
    slug: 'tamarac',
    nearbyCity1: 'Coral Springs',
    nearbyCity2: 'Sunrise',
    permitInfo: 'Yes - Tamarac follows Broward County permitting.',
    installTime: '1-3 days for most installations.',
    localContext: 'Tamarac homeowners upgrade to impact windows for hurricane protection and insurance discounts.'
  },

  // ========== PALM BEACH COUNTY ==========
  'boca-raton': {
    name: 'Boca Raton',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'boca-raton',
    nearbyCity1: 'Delray Beach',
    nearbyCity2: 'Deerfield Beach',
    permitInfo: 'Yes - Boca Raton requires Palm Beach County permits and HOA approval in most communities.',
    installTime: '1-3 days, plus HOA approval time.',
    localContext: 'Boca Raton\'s luxury homes and high-rises require premium impact windows for wind resistance and aesthetic appeal.'
  },
  'delray-beach': {
    name: 'Delray Beach',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'delray-beach',
    nearbyCity1: 'Boca Raton',
    nearbyCity2: 'Boynton Beach',
    permitInfo: 'Yes - Delray Beach follows Palm Beach County permit requirements.',
    installTime: '1-3 days for typical projects.',
    localContext: 'Delray Beach coastal properties benefit from impact windows for hurricane protection and noise reduction.'
  },
  'boynton-beach': {
    name: 'Boynton Beach',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'boynton-beach',
    nearbyCity1: 'Delray Beach',
    nearbyCity2: 'Lake Worth',
    permitInfo: 'Yes - Boynton Beach requires Palm Beach County permits.',
    installTime: '1-3 days for most installations.',
    localContext: 'Boynton Beach residents install impact windows for storm safety and lower insurance premiums.'
  },
  'west-palm-beach': {
    name: 'West Palm Beach',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'west-palm-beach',
    nearbyCity1: 'Palm Beach Gardens',
    nearbyCity2: 'Lake Worth',
    permitInfo: 'Yes - West Palm Beach follows Palm Beach County permitting.',
    installTime: '1-3 days for typical residential projects.',
    localContext: 'West Palm Beach homes and businesses choose impact windows for hurricane protection and energy efficiency.'
  },
  'wellington': {
    name: 'Wellington',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'wellington',
    nearbyCity1: 'West Palm Beach',
    nearbyCity2: 'Royal Palm Beach',
    permitInfo: 'Yes - Wellington requires Palm Beach County permits. Many communities have HOA requirements.',
    installTime: '1-3 days, plus HOA approval time.',
    localContext: 'Wellington\'s equestrian estates and family homes benefit from impact windows for storm safety and noise control.'
  },
  'jupiter': {
    name: 'Jupiter',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'jupiter',
    nearbyCity1: 'Palm Beach Gardens',
    nearbyCity2: 'Tequesta',
    permitInfo: 'Yes - Jupiter follows Palm Beach County permit requirements.',
    installTime: '1-3 days for most projects.',
    localContext: 'Jupiter\'s coastal location demands HVHZ-rated impact windows for hurricane protection.'
  },
  'palm-beach-gardens': {
    name: 'Palm Beach Gardens',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'palm-beach-gardens',
    nearbyCity1: 'Jupiter',
    nearbyCity2: 'West Palm Beach',
    permitInfo: 'Yes - Palm Beach Gardens requires Palm Beach County permits and HOA approval in many communities.',
    installTime: '1-3 days, plus HOA approval.',
    localContext: 'Palm Beach Gardens luxury properties feature premium impact windows for wind resistance and energy savings.'
  },
  'lake-worth': {
    name: 'Lake Worth',
    county: 'Palm Beach',
    state: 'FL',
    slug: 'lake-worth',
    nearbyCity1: 'West Palm Beach',
    nearbyCity2: 'Boynton Beach',
    permitInfo: 'Yes - Lake Worth follows Palm Beach County permitting.',
    installTime: '1-3 days for typical installations.',
    localContext: 'Lake Worth homeowners upgrade to impact windows for hurricane safety and insurance discounts.'
  }
};

// FAQ data - structured for AI consumption
export const commonFAQs = [
  {
    question: 'How much do impact windows cost in South Florida?',
    answer: 'Impact window costs typically range from $15,000 to $40,000+ for a full-house replacement, depending on the number of windows, sizes, and product tier selected. Our Good (ECO) tier offers budget-friendly protection, Better (Mr Glass) provides enhanced performance at mid-range pricing, and Premium (ES Windows) delivers top-tier hurricane protection with lifetime warranties.'
  },
  {
    question: 'Do I need a permit for impact windows?',
    answer: 'Yes. All impact window installations in Florida require building permits. We handle the entire permitting process, including application, fees, coordination with local building departments, and final inspections.'
  },
  {
    question: 'How long does impact window installation take?',
    answer: 'Most residential impact window installations take 1-3 days, depending on the number of openings and project complexity. Custom sizes or full-house replacements may take longer. Installation scheduling depends on permit approval and product manufacturing lead times, which vary by product tier (Good: ~4 weeks, Better: ~6–8 weeks, Premium: ~6–10 weeks).'
  },
  {
    question: 'Are impact windows required in South Florida?',
    answer: 'Impact windows are not legally required for existing homes in most South Florida areas, but they are highly recommended and often required by insurance companies for coverage in high-risk zones. New construction in High-Velocity Hurricane Zones (HVHZ) must have impact-rated windows or approved shutters per Florida Building Code.'
  },
  {
    question: 'What\'s the difference between impact windows and hurricane shutters?',
    answer: 'Impact windows provide permanent, year-round hurricane protection without manual deployment. Shutters require installation before each storm. Impact windows also offer noise reduction, UV protection, energy efficiency, and enhanced security. Shutters are a lower-cost alternative but require storage and labor to install/remove.'
  },
  {
    question: 'Will impact windows lower my homeowners insurance?',
    answer: 'Yes. Most Florida insurance companies offer premium discounts ranging from 10% to 45% for homes with certified impact windows. We provide all necessary documentation (permits, NOAs, installation certificates) to help you claim these discounts with your insurer.'
  }
];

// Helper to get nearby cities for internal linking
export const getNearbyCities = (citySlug) => {
  const city = cityData[citySlug];
  if (!city) return [];
  
  const nearby = [];
  if (city.nearbyCity1) {
    const slug1 = Object.keys(cityData).find(k => cityData[k].name === city.nearbyCity1);
    if (slug1) nearby.push({ name: city.nearbyCity1, slug: slug1 });
  }
  if (city.nearbyCity2) {
    const slug2 = Object.keys(cityData).find(k => cityData[k].name === city.nearbyCity2);
    if (slug2) nearby.push({ name: city.nearbyCity2, slug: slug2 });
  }
  return nearby;
};

export default cityData;
